(function () {
  function init() {
    var root = document.querySelector('[data-shop-grid]');
    if (!root) return;

    var cardGrid = root.querySelector('[data-shop-card-grid]');
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-shop-card]'));
    var priceMinInput = root.querySelector('[data-filter-price-min]');
    var priceMaxInput = root.querySelector('[data-filter-price-max]');
    var includeCheckboxes = Array.prototype.slice.call(root.querySelectorAll('[data-filter-checkbox]'));
    var excludeCheckboxes = Array.prototype.slice.call(root.querySelectorAll('[data-filter-checkbox-exclude]'));
    var clearBtn = root.querySelector('[data-filter-clear]');
    var sortSelect = root.querySelector('[data-sort-select]');
    var perPageSelect = root.querySelector('[data-per-page-select]');
    var pagination = root.querySelector('[data-pagination]');
    var visibleCountEl = root.querySelector('[data-visible-count]');
    var emptyMessage = root.querySelector('[data-empty-message]');
    var isCollection = root.getAttribute('data-is-collection') === 'true';
    var collectionUrl = root.getAttribute('data-collection-url');

    var PER_PAGE_KEY = 'bkj_shop_per_page';
    var WISHLIST_KEY = 'bkj_wishlist';
    var currentPage = 1;

    function getWishlist() {
      try { return JSON.parse(localStorage.getItem(WISHLIST_KEY)) || []; } catch (e) { return []; }
    }
    function setWishlist(list) {
      try { localStorage.setItem(WISHLIST_KEY, JSON.stringify(list)); } catch (e) {}
    }

    function initWishlistState() {
      var wishlist = getWishlist();
      cards.forEach(function (card) {
        var btn = card.querySelector('[data-wishlist-toggle]');
        if (!btn) return;
        var id = btn.getAttribute('data-product-id');
        if (wishlist.indexOf(id) !== -1) btn.classList.add('is-active');
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          var list = getWishlist();
          var idx = list.indexOf(id);
          if (idx === -1) {
            list.push(id);
            btn.classList.add('is-active');
          } else {
            list.splice(idx, 1);
            btn.classList.remove('is-active');
          }
          setWishlist(list);
        });
      });
    }

    function initAddToCart() {
      cards.forEach(function (card) {
        var btn = card.querySelector('[data-add-to-cart]');
        if (!btn) return;
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          var variantId = btn.getAttribute('data-variant-id');
          if (!variantId || btn.classList.contains('is-loading')) return;
          btn.classList.add('is-loading');
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
          })
            .then(function (res) { return res.json(); })
            .then(function () {
              btn.classList.remove('is-loading');
              btn.classList.add('is-added');
              setTimeout(function () { btn.classList.remove('is-added'); }, 1500);
              return fetch('/cart.js').then(function (r) { return r.json(); });
            })
            .then(function (cart) {
              var countEl = document.querySelector('.cart-count');
              if (countEl && cart) countEl.textContent = cart.item_count;
            })
            .catch(function () {
              btn.classList.remove('is-loading');
            });
        });
      });
    }

    function cardMatchesFilters(card) {
      var price = parseFloat(card.getAttribute('data-price'));
      var tags = (card.getAttribute('data-tags') || '').split(',');

      var min = parseFloat(priceMinInput.value);
      var max = parseFloat(priceMaxInput.value);
      if (!isNaN(min) && price < min) return false;
      if (!isNaN(max) && price > max) return false;

      var groups = {};
      includeCheckboxes.forEach(function (cb) {
        if (!cb.checked) return;
        var group = cb.closest('[data-filter-group]').getAttribute('data-filter-group');
        groups[group] = groups[group] || [];
        groups[group].push(cb.value);
      });
      for (var group in groups) {
        var matches = groups[group].some(function (val) { return tags.indexOf(val) !== -1; });
        if (!matches) return false;
      }

      var excluded = excludeCheckboxes.some(function (cb) {
        return cb.checked && tags.indexOf(cb.value) !== -1;
      });
      if (excluded) return false;

      return true;
    }

    function applySort() {
      var mode = sortSelect.value;
      if (mode === 'best-selling') {
        if (isCollection) {
          window.location.href = collectionUrl + '?sort_by=best-selling';
        }
        return;
      }
      var sorted = cards.slice();
      if (mode === 'price-asc') {
        sorted.sort(function (a, b) { return parseFloat(a.getAttribute('data-price')) - parseFloat(b.getAttribute('data-price')); });
      } else if (mode === 'price-desc') {
        sorted.sort(function (a, b) { return parseFloat(b.getAttribute('data-price')) - parseFloat(a.getAttribute('data-price')); });
      } else if (mode === 'title-asc') {
        sorted.sort(function (a, b) { return a.getAttribute('data-title').localeCompare(b.getAttribute('data-title')); });
      } else if (mode === 'title-desc') {
        sorted.sort(function (a, b) { return b.getAttribute('data-title').localeCompare(a.getAttribute('data-title')); });
      } else {
        return; // featured = original DOM order, no reorder needed
      }
      sorted.forEach(function (card) { cardGrid.appendChild(card); });
    }

    function getPerPage() {
      var val = perPageSelect.value;
      return val === 'all' ? Infinity : parseInt(val, 10);
    }

    function render() {
      var visible = cards.filter(cardMatchesFilters);
      cards.forEach(function (card) { card.style.display = 'none'; });

      var perPage = getPerPage();
      var totalPages = Math.max(1, Math.ceil(visible.length / perPage));
      if (currentPage > totalPages) currentPage = totalPages;

      var start = (currentPage - 1) * perPage;
      var end = perPage === Infinity ? visible.length : start + perPage;
      var pageItems = visible.slice(start, end);
      pageItems.forEach(function (card) { card.style.display = ''; });

      if (visibleCountEl) visibleCountEl.textContent = visible.length;
      if (emptyMessage) emptyMessage.style.display = visible.length === 0 ? 'block' : 'none';

      renderPagination(totalPages);
    }

    function renderPagination(totalPages) {
      if (!pagination) return;
      pagination.innerHTML = '';
      if (totalPages <= 1) return;
      for (var i = 1; i <= totalPages; i++) {
        var btn = document.createElement('button');
        btn.textContent = i;
        if (i === currentPage) btn.classList.add('is-active');
        (function (page) {
          btn.addEventListener('click', function () {
            currentPage = page;
            render();
            root.scrollIntoView({ behavior: 'smooth' });
          });
        })(i);
        pagination.appendChild(btn);
      }
    }

    function onFilterChange() {
      currentPage = 1;
      render();
    }

    priceMinInput.addEventListener('input', onFilterChange);
    priceMaxInput.addEventListener('input', onFilterChange);
    includeCheckboxes.forEach(function (cb) { cb.addEventListener('change', onFilterChange); });
    excludeCheckboxes.forEach(function (cb) { cb.addEventListener('change', onFilterChange); });

    if (clearBtn) {
      clearBtn.addEventListener('click', function () {
        priceMinInput.value = '';
        priceMaxInput.value = '';
        includeCheckboxes.forEach(function (cb) { cb.checked = false; });
        excludeCheckboxes.forEach(function (cb) { cb.checked = false; });
        onFilterChange();
      });
    }

    sortSelect.addEventListener('change', function () {
      applySort();
      currentPage = 1;
      render();
    });

    perPageSelect.addEventListener('change', function () {
      try { localStorage.setItem(PER_PAGE_KEY, perPageSelect.value); } catch (e) {}
      currentPage = 1;
      render();
    });

    var storedPerPage = null;
    try { storedPerPage = localStorage.getItem(PER_PAGE_KEY); } catch (e) {}
    if (storedPerPage && perPageSelect.querySelector('option[value="' + storedPerPage + '"]')) {
      perPageSelect.value = storedPerPage;
    }

    function initFilterToggle() {
      var sidebar = root.querySelector('[data-shop-sidebar]');
      var overlay = root.querySelector('[data-filter-overlay]');
      var toggleBtns = Array.prototype.slice.call(root.querySelectorAll('[data-filter-toggle]'));
      if (!sidebar || toggleBtns.length === 0) return;

      function open() {
        sidebar.classList.add('is-open');
        if (overlay) overlay.classList.add('is-open');
      }
      function close() {
        sidebar.classList.remove('is-open');
        if (overlay) overlay.classList.remove('is-open');
      }

      toggleBtns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (sidebar.classList.contains('is-open')) close(); else open();
        });
      });
      if (overlay) overlay.addEventListener('click', close);
    }

    initWishlistState();
    initAddToCart();
    initFilterToggle();
    render();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
